import ReactMarkdown from "react-markdown";

/* eslint-disable-next-line */
export interface LHelloBarProps {
  content?: string; // richtext
}

export function LHelloBar({ content }: LHelloBarProps) {
  return (
    <div className="z-50 w-full p-2 text-center bg-ekdeepred hello-bar">
      <ReactMarkdown>{content || ""}</ReactMarkdown>
    </div>
  );
}

export default LHelloBar;
